<template>
  <div class="toolUI">
    <div class="colorSelector">
      <div v-for="i in colors" class="palette__colorItem">
        <div class="colorButton" :class="{ selected: isSelectedColor(i) }">
          <div
            class="colorButton__color"
            :style="{ backgroundColor: getColor(i) }"
            @click="changeColor(i)"
          ></div>
        </div>
      </div>
    </div>
    <div class="sizeButtonContainer">
      <div
        class="sizeButton sizeButton--1"
        :class="{ sizeButtonSelected: isSelectedSize(1) }"
        @click="changeSize(1)"
      >
        <div class="sizeButton__image sizeButton__image--1">
          <div class="sizeButton__marker"></div>
        </div>
      </div>
      <div
        class="sizeButton sizeButton--2"
        :class="{ sizeButtonSelected: isSelectedSize(2) }"
        @click="changeSize(2)"
      >
        <div class="sizeButton__image sizeButton__image--2">
          <div class="sizeButton__marker"></div>
        </div>
      </div>
      <div
        class="sizeButton sizeButton--3"
        :class="{ sizeButtonSelected: isSelectedSize(3) }"
        @click="changeSize(3)"
      >
        <div class="sizeButton__image sizeButton__image--3">
          <div class="sizeButton__marker"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../store/modules/tool/types";
import * as StoreUtil from "../../util/StoreUtil";
export default {
  name: "TabletToolUI",
  data() {
    return {
      colors: [6, 7]
    };
  },
  computed: {
    tool() {
      return this.$store.state.tool;
    },
    colorPalette() {
      return this.$store.state.tool.colorPalette;
    },
    size() {
      return this.tool.size;
    }
  },
  methods: {
    changeColor(type) {
      this.$store.dispatch(types.namespace + types.SET_COLOR, type);
    },
    isSelectedColor(index) {
      return this.tool.color == index;
    },
    isSelectedSize(index) {
      return this.tool.size == index;
    },
    changeSize(type) {
      this.$store.dispatch(types.namespace + types.SET_SIZE, type);
    },
    getColor(index) {
      return this.colorPalette[index];
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
@import "../../sass/colorbutton"
.toolUI
  @include flexCenter
  width: 638px

.colorSelector
  margin-right: 24px
  display: flex
  align-items: center
  justify-content: space-evenly
  position: relative
  width: 120px
  .palette__colorItem
    width: 48px
    height: 48px
.colorButton
  &:after
    width: 42px
    height: 42px
    border-radius: 42px
  &:before
    width: 48px
    height: 48px
    border-radius: 48px
    left: -3px
    top: -3px
  .colorButton__color
    width: 34px
    height: 34px
    border-radius: 34px

.sizeButtonContainer
  width: 500px
  display: flex
  justify-content: space-between

.sizeButton
  width: 150px
  height: 42px
  border-radius: 42px
  background-color: $button_bg
  border: 2px solid $button_bg
  @include flexCenter
  border-right: 1px solid $separator_border
  transition: all cubic-bezier(0.115, 0.525, 0.440, 1.330) 0.18s

  &:after
    transition: all cubic-bezier(0.115, 0.525, 0.440, 1.330) 0.18s
    border-radius: 42px
    content: ""
    display: block
    background-color: #fff
    position: absolute
    z-index: -1
    width: 100px
    height: 10px



  &.sizeButtonSelected
    padding: 0
    border: 2px solid $button_border
    &:after
      width: 150px
      height: 42px



.sizeButton__spray, .sizeButton__marker
  display: block
.sizeButton__image
  background-size: contain !important
.sizeButton__image--1
    width: 235px * 0.5
    height: 8px * 0.5
    background: url("../../assets/tablet/size1.png") no-repeat 0 0
.sizeButton__image--2
    width: 237px * 0.5
    height: 18px * 0.5
    background: url("../../assets/tablet/size2.png") no-repeat 0 0
.sizeButton__image--3
    width: 237px * 0.5
    height: 28px * 0.5
    background: url("../../assets/tablet/size3.png") no-repeat 0 0
</style>
